import { createContext, useContext } from 'react';

const DesignContext = createContext({ isNewDesign: false });

export function DesignProvider({ children }) {
  return (
    <DesignContext.Provider value={{ isNewDesign: false }}>
      {children}
    </DesignContext.Provider>
  );
}

export function useDesign() {
  return useContext(DesignContext);
}
